
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import queryDescriptor from './DatasetManagementQueryDataset.json'

    export default defineComponent({
        components: { Dialog },
        props: {},
        emits: ['close'],
        data() {
            return {
                queryDescriptor
            }
        }
    })
